import { gsap } from 'gsap';
import ScrambleText from 'scramble-text';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const scrambleWords = () => {
  const textContainer = document.querySelectorAll('.scramble-text');

  textContainer.forEach((container) => {
    const titles = container.querySelectorAll('.title-lg');
    ScrollTrigger.create({
      trigger: container,
      start: 'top bottom-=50px',
      onEnter: () => {
        titles.forEach((word) => {
          new ScrambleText(word, {
            timeOffset: 30,
            chars: '_',
          }).start();
        });
      }
    });
  });
};

export default scrambleWords;
